/**
 * Clarinet artwork — Fugue Lab's own illustration, drawn in house by
 * Danielle Dinstman (`clarinet-01.svg`, 87 shapes), flattened to path data.
 *
 * It is a Fugue Lab asset, not Sam's and not licensed stock, so it is free to
 * reuse across client and demo sites — and it is the same drawing that stands
 * as a Graphic Design entry in the studio portfolio.
 *
 * GENERATED, do not hand-edit. Rects were converted to paths so every shape
 * can carry `pathLength={1}` and take the same dash-offset draw-on; the
 * source's four Illustrator classes became the four `r` roles below; and the
 * 612x792 page was cropped to the instrument's own bounds.
 *
 * Document order is the source's order and is load-bearing — keywork overlaps
 * body, so the array must not be sorted. Per-part motion therefore rides on
 * each shape (`o`, `py`), not on a wrapping <g> that would reorder them.
 *
 *   r   role: b = body, k = keywork, m = mouthpiece tip, l = unfilled line
 *   y   the shape's own centre, 0 (mouthpiece) .. 1 (bell) — staggers the draw
 *   py  its PART's centre — so a part travels as one piece
 *   o   that part's assembly offset in user units, telescoping out from the
 *       centre joint: the instrument pulls together as the section scrolls
 */
export const CLARINET_VIEWBOX = '255.4 49.6 106.8 695.5'

export type ClarinetShape = {
  d: string
  r: 'b' | 'k' | 'm' | 'l'
  y: number
  py: number
  o: number
}

export const CLARINET_SHAPES: ClarinetShape[] = [
  {
    d: 'M326.25,460.98c1.23-5.73,2.51-10.55,3.56-14.21.46-1.62,3.73-12.87,8.82-24.66,1.9-4.39,2.84-6.59,4.02-8.49,1.88-3.03,3.07-4.06,3.96-6.95.5-1.64,1.32-4.46,0-7.19-.31-.64-1.11-2.3-2.83-2.98-2.54-1-5.63.74-7.17,2.41-2.78,3.01-1.59,6.92-1.46,13.44.15,7.67-1.28,13.24-3.82,23.1-.94,3.66-2.5,8.93-5.09,15.16v10.37Z',
    r: 'k',
    y: 0.545,
    py: 0.663,
    o: 20,
  },
  { d: 'M328.68,442.54h2.41v55.85h-2.41Z', r: 'k', y: 0.607, py: 0.663, o: 20 },
  {
    d: 'M296.42,87.73c-.2,2.13-.39,4.28-.57,6.46-.02.23-.04.47-.06.72,0,.12-.02.25-.03.38,0,.05-.01.1-.02.16-.01.23-.04.54-.07.98-.01.27-.03.59-.05.96h-.03c-.19,0-.39-.02-.59-.05-2.66-.39-4.5-2.85-4.12-5.51.39-2.65,2.86-4.5,5.51-4.11.01,0,.02,0,.03.01Z',
    r: 'k',
    y: 0.054,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M294.75,106.59c-.1,2.14-.19,4.29-.27,6.48,0,.23-.02.47-.03.72,0,.12,0,.25-.01.38,0,.05,0,.1-.01.16,0,.23-.01.54-.02.98,0,.27,0,.59,0,.96h-.03c-.19.01-.39,0-.59-.02-2.68-.26-4.63-2.64-4.37-5.31.27-2.67,2.65-4.63,5.31-4.36,0,0,.02,0,.03,0Z',
    r: 'k',
    y: 0.082,
    py: 0.136,
    o: -27,
  },
  {
    d: 'M325.73,279.1c-.02,11.96-.04,24.43-.05,37.25v2.07c0,3.16-.01,6.34-.01,9.54v5.84c-.13-.07-1.57-.76-2.95,0-1.22.68-1.46,2-1.5,2.23-.27,1.45.52,2.62.93,3.42,1.7,3.34.57,7.9-.97,10.48-1.97,3.29-5.32,4.52-6.04,4.79-1.4.51-1.74.33-9.14.91-3.77.29-5.84.51-6.48,1.86-.24.52-.28,1.23,0,1.79.84,1.65,4.21,1.42,7.52,1.19,3.27-.22,6.46-.47,10.19-2.31.46-.23,1.06-.53,1.75-.95.73,1.28,2.39,2.49,4.13,2.59.37.02,1.5.07,2.55-.64,0,5.44,0,10.92.01,16.42-2.99.74-4.52,3.15-9.16,5.26-1.97.89-4.86,2.2-8.61,2.04-1.39-.07-6.6-.29-9.43-4.04-1.81-2.39-1.99-5.34-2.24-9.34-.1-1.61-.06-2.96,0-3.91h-3.79c0-6.36-.01-12.82-.01-19.37h5.53c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67c-4.34,0-7.97,2.56-8.88,5.97h-5.69v-.84c0-4.05,0-8.09-.01-12.14h7.62c.08.07.15.13.23.2.07.15.14.29.23.43,0,.02.01.03.02.05.77,1.93,2.76,3.39,5.18,3.71.34.06.69.08,1.05.08.2,0,.39-.01.59-.03,3.21-.24,5.76-2.44,5.99-5.19.01-.14.02-.27.02-.41s0-.28-.02-.41c-.01-.16-.03-.32-.07-.47-.46-2.52-2.9-4.49-5.92-4.71-.2-.02-.39-.03-.59-.03-.34,0-.68.02-1.01.07-2.55.33-4.63,1.91-5.32,3.99-.01.02-.02.03-.03.05-.11.02-.23.04-.35.06h-7.62c0-5.2,0-10.39-.01-15.59h5.65c.76,3.23,4.31,5.67,8.59,5.67,4.83,0,8.74-3.12,8.74-6.97s-3.91-6.97-8.74-6.97c-4.28,0-7.83,2.44-8.59,5.67h-5.66c0-2.74,0-5.48-.01-8.22,0-4.42-.01-8.84-.02-13.25h7.15c-.37,1.14-.58,2.39-.58,3.7,0,5.34,3.45,9.67,7.71,9.67s7.7-4.33,7.7-9.67-3.45-9.67-7.7-9.67c-2.34,0-4.44,1.31-5.85,3.37h-8.43c0-.94,0-1.88-.01-2.82,0-3.32,0-6.65-.01-9.97v-1.1c.34,2.88,2.79,5.11,5.76,5.11,2.63,0,4.85-1.74,5.57-4.14h2.07v7.5h3.34v-7.5h9.57v6.01c0,1.32,1.07,2.39,2.39,2.39h2.31c1.23,0,2.25-.94,2.37-2.15Z',
    r: 'b',
    y: 0.398,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M300.42,327.92s-.04.11-.06.16c-.1-.03-.21-.05-.32-.05.12-.02.24-.04.35-.06.01-.02.02-.03.03-.05Z',
    r: 'l',
    y: 0.399,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M300.5,331.27c-.09-.14-.16-.28-.23-.43-.08-.07-.15-.13-.23-.2.08,0,.16-.01.24-.02.05.22.12.44.22.65Z',
    r: 'l',
    y: 0.403,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M325.67,333.8c-.01,5.05-.01,10.15-.01,15.28v10.08c-1.05.71-2.18.66-2.55.64-1.74-.1-3.4-1.31-4.13-2.59-.69.42-1.29.72-1.75.95-3.73,1.84-6.92,2.09-10.19,2.31-3.31.23-6.68.46-7.52-1.19-.28-.56-.24-1.27,0-1.79.64-1.35,2.71-1.57,6.48-1.86,7.4-.58,7.74-.4,9.14-.91.72-.27,4.07-1.5,6.04-4.79,1.54-2.58,2.67-7.14.97-10.48-.41-.8-1.2-1.97-.93-3.42.04-.23.28-1.55,1.5-2.23,1.38-.76,2.82-.07,2.95,0Z',
    r: 'l',
    y: 0.426,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M306.47,91.55c.01-2.19.02-4.37.03-6.56h-9.81c-.18,2.02-.35,4.13-.53,6.33h2.85c0,.23.01.45.01.68-.57,1.13-1.32,2.9-1.68,5.1-.14.82-.22,1.7-.22,2.64,0,.84.01,2.55.69,4.64.4,1.26.89,2.19,1.21,2.74,0,.23-.01.45-.01.68h-3.73c.03-1.5.07-2.85.1-4.02.04-1.55.09-2.82.13-3.87-.3,4.13-.6,8.52-.9,13.15h11.86v-5.92c-3.46-.91-6-4.06-6-7.8s2.54-6.88,6-7.79ZM314.77,56.11c-.23-.03-2.58-.3-6.87-.24,0,0-4.63-.05-6.27.24-1.37.24-2.72,7.26-4.04,19.72.14.09.29.18.46.28,1.83,1.11,5.25,2.81,9.85,3.14,5.12.37,9.1-1.15,11.1-2.11.18-.08.34-.16.48-.23-1.75-17.28-2.87-20.58-4.71-20.8ZM310.58,107.14v5.92h11.85c-.34-4.41-.68-8.82-1.02-13.23.04,1.06.09,2.36.13,3.95.03,1.17.07,2.52.1,4.02h-3.73c0-.23,0-.45,0-.68.32-.55.81-1.48,1.21-2.74.68-2.09.69-3.8.69-4.64,0-3.43-1.12-6.19-1.9-7.74,0-.23,0-.45,0-.68h2.85c.21,2.81.43,5.62.65,8.43-.05-1.32-.1-2.28-.13-2.97-.01-.1-.02-.19-.02-.28-.01-.11-.02-.2-.02-.29-.01-.13-.02-.24-.03-.35-.01-.16-.02-.3-.03-.41-.01-.06-.02-.11-.02-.16,0-.13-.02-.26-.03-.38-.02-.25-.04-.49-.06-.72-.28-3.35-.54-6.41-.8-9.2h-9.7c0,2.19.01,4.37.01,6.56,3.45.92,6,4.05,6,7.79s-2.55,6.88-6,7.8ZM323.54,124.79c-4.5-.65-9.77-1.11-15.64-1.06-5.2.04-9.91.46-14.01,1.05-.15,2.66-.3,5.31-.46,7.97,4.43-.44,9.27-.73,14.47-.76,5.85-.04,11.25.26,16.14.74-.16-2.65-.33-5.29-.5-7.94ZM326.16,158.57c-.03,5.18-.07,13.24-.12,23.63-5.46-.35-11.25-.55-17.36-.54-5.81.01-11.33.21-16.55.54v.06c.03,2.64.06,5.29.09,7.94,5.28-.37,10.91-.58,16.87-.58s11.62.22,16.92.58c-.02,6.44-.05,13.57-.08,21.29-.07,18.51-.14,40.44-.19,64.5v-14.09c0-1.32-1.07-2.39-2.38-2.39h-2.31c-1.32,0-2.39,1.07-2.39,2.39v7.61h-9.57v-4.15c2.39-.72,4.14-2.93,4.14-5.56,0-3.21-2.61-5.81-5.81-5.81s-5.81,2.6-5.81,5.81c0,2.63,1.74,4.85,4.14,5.57v4.14h-2.08c-.72-2.39-2.93-4.14-5.56-4.14-2.98,0-5.43,2.25-5.77,5.13,0,.46,0,.92,0,1.38.34,2.88,2.79,5.11,5.76,5.11,2.63,0,4.85-1.74,5.57-4.14h2.07v7.5h3.34v-7.5h9.57v6.01c0,1.32,1.07,2.39,2.39,2.39h2.31c1.23,0,2.25-.94,2.37-2.15-.02,11.96-.04,24.43-.05,37.25.04-26.86.1-52.03.17-74.01,0-1.05.01-2.09.01-3.12.01-4.13.03-8.14.04-12.02,0-.97,0-1.94,0-2.89.01-1.91.01-3.79.02-5.63.04-10.73.08-20.31.11-28.48.01-.91.01-1.8.01-2.67.09-17.88.15-28.35.15-28.42-.01-.18-.03-.36-.04-.54ZM292.27,235.86c.01,4.55.02,9.08.03,13.57,0-4.52-.02-9.05-.03-13.57Z',
    r: 'l',
    y: 0.191,
    py: 0.136,
    o: -27,
  },
  {
    d: 'M326.01,190.2c-.02,6.44-.05,13.57-.08,21.29-.07,18.51-.14,40.44-.19,64.5v-14.09c0-1.32-1.07-2.39-2.38-2.39h-2.31c-1.32,0-2.39,1.07-2.39,2.39v7.61h-9.57v-4.15c2.39-.72,4.14-2.93,4.14-5.56,0-3.21-2.61-5.81-5.81-5.81s-5.81,2.6-5.81,5.81c0,2.63,1.74,4.85,4.14,5.57v4.14h-2.08c-.72-2.39-2.93-4.14-5.56-4.14-2.98,0-5.43,2.25-5.77,5.13,0-7.02-.02-14.05-.04-21.07,0-4.52-.02-9.05-.03-13.57-.01-2.53-.01-5.07-.02-7.6t.02.02c.56.69,1.27,1.17,2.09,1.24.79.06,1.57-.26,2.25-.84,1.22-1,2.11-2.79,2.1-4.5,0-.32-.03-.64-.09-.95-.06-.32-.14-.64-.25-.94-.16-.46-.38-.9-.64-1.3-.08-.14-.17-.27-.27-.39-.82-1.11-1.96-1.84-3.1-1.75-.22.02-.43.06-.64.15-.56.19-1.06.59-1.49,1.11v-.34c-.03-12.28-.06-24.79-.1-37.51.03,2.64.06,5.29.09,7.94,5.28-.37,10.91-.58,16.87-.58s11.62.22,16.92.58Z',
    r: 'b',
    y: 0.254,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M326.16,158.53v.04c-.03,5.18-.07,13.24-.12,23.63-5.46-.35-11.25-.55-17.36-.54-5.81.01-11.33.21-16.55.54-.02-7.75-.04-15.59-.07-23.5.46-9.13.91-17.8,1.37-25.95,4.43-.44,9.27-.73,14.47-.76,5.85-.04,11.25.26,16.14.74-.16-2.65-.33-5.29-.5-7.94.77,9.81,1.63,20.99,2.62,33.74Z',
    r: 'b',
    y: 0.143,
    py: 0.136,
    o: -27,
  },
  {
    d: 'M321.28,96.78c.03.69.08,1.65.13,2.97v.08c.34,4.41.68,8.82,1.02,13.23h-11.85v-5.92c3.45-.92,6-4.06,6-7.8s-2.55-6.87-6-7.79c0-2.19-.01-4.37-.01-6.56h9.7c-2.23-24.59-3.4-28.88-5.5-29.13-.23-.02-2.58-.3-6.87-.24,0,0-4.63-.04-6.27.24-1.69.3-3.33,10.84-4.94,29.13h9.81c-.01,2.19-.02,4.37-.03,6.56-3.46.91-6,4.05-6,7.79s2.54,6.89,6,7.8v5.92h-11.86c-.24,3.75-.48,7.66-.72,11.72,4.1-.59,8.81-1.01,14.01-1.05,5.87-.05,11.14.41,15.64,1.06-.85-10.97-1.59-20.23-2.26-28.01ZM307.9,79.25c-4.6-.33-8.02-2.03-9.85-3.14-.17-.1-.32-.19-.46-.28,1.32-12.46,2.67-19.48,4.04-19.72,1.64-.29,6.27-.24,6.27-.24,4.29-.06,6.64.21,6.87.24,1.84.22,2.96,3.52,4.71,20.8-.14.07-.3.15-.48.23-2,.96-5.98,2.48-11.1,2.11Z',
    r: 'b',
    y: 0.051,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M301.64,411.8h-9.23c0-1.03.01-2.08,0-3.12h9.23c.12-.02.24-.04.37-.07,1.33-3.02,3.89-4.93,6.59-4.91,3.25.04,6.84,2.88,6.84,6.71s-3.6,6.67-6.84,6.72c-2.78.04-5.41-1.95-6.73-5.1-.07-.08-.15-.16-.23-.23Z',
    r: 'l',
    y: 0.519,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M307.55,446.77c-4.34,0-7.97,2.56-8.88,5.97h-6.35c0,.87,0,1.74-.01,2.6h6.2c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67ZM307.6,459.05c-3.26,0-5.89-2.17-5.89-4.84s2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84-2.63,4.84-5.88,4.84Z',
    r: 'l',
    y: 0.584,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M307.55,420.11c-4.34,0-7.97,2.56-8.88,5.97h-6.28c0,.87,0,1.74-.01,2.6h6.13c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67ZM307.6,432.39c-3.26,0-5.89-2.17-5.89-4.84s2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84-2.63,4.84-5.88,4.84Z',
    r: 'l',
    y: 0.545,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M308.15,469.18c-4.45,0-8.17,2.81-9.1,6.56h-6.8c-.01.96-.01,1.91-.02,2.86h6.66c.53,4.2,4.48,7.44,9.26,7.44,5.16,0,9.34-3.77,9.34-8.43s-4.18-8.43-9.34-8.43ZM308.2,482.68c-3.34,0-6.03-2.39-6.03-5.32s2.69-5.33,6.03-5.33,6.03,2.39,6.03,5.33-2.69,5.32-6.03,5.32Z',
    r: 'l',
    y: 0.617,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M325.67,375.58v18.45h-33.24v-8.69c.01-.07.01-.15,0-.22.01-6.31.01-12.72.01-19.23v-.3h3.79c-.06.95-.1,2.3,0,3.91.25,4,.43,6.95,2.24,9.34,2.83,3.75,8.04,3.97,9.43,4.04,3.75.16,6.64-1.15,8.61-2.04,4.64-2.11,6.17-4.52,9.16-5.26Z',
    r: 'l',
    y: 0.474,
    py: 0.367,
    o: -11,
  },
  { d: 'M325.99,487.02c-.46-8.06-.44-14.68-.1-20.14.03,6.77.07,13.5.1,20.14Z', r: 'l', y: 0.616, py: 0.663, o: 20 },
  {
    d: 'M355.77,726.45c-.03-.08-.07-.15-.11-.22,0-.01,0-.01,0-.01-.05-.08-.11-.16-.18-.24-.06-.06-.12-.13-.19-.19-.02-.02-.03-.03-.05-.05-.12-.1-.26-.22-.43-.34-.65-.48-1.59-1.06-2.8-2.01-7.22,4.01-23.86,8.5-42.87,8.49-19.01.01-35.65-4.48-42.87-8.49-1.21.95-2.15,1.53-2.8,2.01-.17.12-.31.24-.43.34-.02.02-.03.03-.05.05-.07.06-.13.13-.19.19-.07.08-.13.16-.18.24,0,0-.01,0-.01.01-.04.07-.08.14-.11.22-.04.1-.06.19-.07.3-.31,4.14,21.03,12.33,46.71,12.32,25.68,0,47.02-8.18,46.71-12.32-.01-.11-.03-.2-.07-.3ZM327.88,623.28c-5.55.94-12.17,1.65-19.63,1.66-6.62.01-12.56-.54-17.65-1.29l-.18,7.32c4.92.91,10.81,1.63,17.48,1.7,7.86.08,14.71-.76,20.23-1.82-.08-2.52-.16-5.04-.25-7.57Z',
    r: 'b',
    y: 0.915,
    py: 0.913,
    o: 48,
  },
  {
    d: 'M352,723.39c-7.22,4.01-23.86,8.5-42.87,8.49-19.01.01-35.65-4.48-42.87-8.49,1.02-.8,2.24-1.86,3.63-3.33,0,0,2.19-2.32,4.45-5.64,6.32-9.28,9.1-27.4,9.98-32.03,1.9-10.08,4.13-21.14,4.44-24.82.78-9.01,1.42-23.81,1.93-44.03,2.5-.15,4.6-2.49,5.55-5.8h8.78v2.62c-.7.58-1.14,1.45-1.14,2.43,0,1.74,1.41,3.16,3.16,3.16s3.16-1.42,3.16-3.16c0-1.13-.6-2.12-1.49-2.68,0-.8,0-1.58.02-2.37h1.24c.95,0,1.72-.78,1.72-1.73v-.42c0-.95-.77-1.72-1.72-1.72h-1.21c.11-12.1.17-23.38.2-33.59h8.99c.98,3.43,3.21,5.82,5.82,5.82,1.12,0,2.18-.44,3.09-1.23.28,18.32.61,34.72,1.02,48.41-5.55.94-12.17,1.65-19.63,1.66-6.62.01-12.56-.54-17.65-1.29l-.18,7.32c4.92.91,10.81,1.63,17.48,1.7,7.86.08,14.71-.76,20.23-1.82.39,11.43.85,20.53,1.37,26.72.31,3.68,2.54,14.74,4.44,24.82.88,4.63,3.66,22.75,9.98,32.03,2.25,3.32,4.45,5.64,4.45,5.64,1.39,1.47,2.61,2.53,3.63,3.33Z',
    r: 'b',
    y: 0.871,
    py: 0.913,
    o: 48,
  },
  {
    d: 'M305,603.87h-8.23c0-5-2.48-9.12-5.67-9.63.29-14.94.51-32.04.7-51.22.78-.26,1.5-.74,2.14-1.39,1.67-1.71,2.2-3.59,2.3-4.2,2.47.3,5.14.52,7.98.62.17,7.06.34,16.68.48,28.36h-.48c-.95,0-1.72.77-1.72,1.72v.42c0,.95.77,1.73,1.72,1.73h.53c.1,9.94.19,21.23.25,33.59Z',
    r: 'b',
    y: 0.754,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M326.86,574.87c-.91.79-1.97,1.23-3.09,1.23-2.61,0-4.84-2.39-5.82-5.82h-8.99c-.03,10.21-.09,21.49-.2,33.59h1.21c.95,0,1.72.77,1.72,1.72v.42c0,.95-.77,1.73-1.72,1.73h-1.24c-.01.79-.02,1.57-.02,2.37.89.56,1.49,1.55,1.49,2.68,0,1.74-1.42,3.16-3.16,3.16s-3.16-1.42-3.16-3.16c0-.98.44-1.85,1.14-2.43v-2.62h-8.78c-.95,3.31-3.05,5.65-5.55,5.8.15-5.96.29-12.4.41-19.3,3.19.51,5.67,4.63,5.67,9.63h8.23c-.06-12.36-.15-23.65-.25-33.59h-.53c-.95,0-1.72-.78-1.72-1.73v-.42c0-.95.77-1.72,1.72-1.72h.48c-.14-11.68-.31-21.3-.48-28.36-2.84-.1-5.51-.32-7.98-.62-.1.61-.63,2.49-2.3,4.2-.64.65-1.36,1.13-2.14,1.39.06-6.08.11-12.37.16-18.86.03-3,.05-6.05.07-9.14.02-2.97.04-5.99.06-9.04,0-1.78.02-3.57.03-5.38.02-2.88.03-5.8.05-8.75.02-4.34.04-8.76.06-13.25h6.66c.53,4.2,4.48,7.44,9.26,7.44,5.16,0,9.34-3.77,9.34-8.43s-4.18-8.43-9.34-8.43c-4.45,0-8.17,2.81-9.1,6.56h-6.8c.02-6.64.05-13.44.06-20.4h6.2c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67c-4.34,0-7.97,2.56-8.88,5.97h-6.35c.03-7.82.05-15.85.06-24.06h6.13c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67c-4.34,0-7.97,2.56-8.88,5.97h-6.28c.01-4.7.02-9.46.02-14.28h9.23c.08.07.16.15.23.23,1.32,3.15,3.95,5.14,6.73,5.1,3.24-.05,6.84-2.88,6.84-6.72s-3.59-6.67-6.84-6.71c-2.7-.02-5.26,1.89-6.59,4.91-.13.03-.25.05-.37.07h-9.23c.01-4.82.02-9.71.02-14.65h33.24v-7.78c.02,17.65.06,35.47.11,53.13v.66c.03,8.98.07,17.92.11,26.77v.07c-.34,5.46-.36,12.08.1,20.14v.08c.02,2.58.04,5.14.05,7.69.01,1.53.02,3.06.03,4.58.02,2.24.03,4.47.05,6.68.01,1.17.02,2.33.03,3.49.12,16.86.28,33.05.47,48.21.07,5.87.15,11.58.24,17.12Z',
    r: 'b',
    y: 0.652,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M290.87,224.93c-.05-.45-.05-.93.01-1.4.05-.48.15-.95.31-1.41.01-.03.02-.07.03-.1.01-.02.01-.05.03-.07-.12.41-.5,1.62-.38,2.98Z',
    r: 'k',
    y: 0.246,
    py: 0.367,
    o: -11,
  },
  { d: 'M292.3,249.43c-.01-4.49-.02-9.02-.03-13.57.01,4.52.03,9.05.03,13.57Z', r: 'k', y: 0.274, py: 0.367, o: -11 },
  { d: 'M292.43,346.22v22.53s-.04.01-.06.02v-22.55h.06Z', r: 'l', y: 0.442, py: 0.367, o: -11 },
  {
    d: 'M292.4,309.84h-.03v-21.47c.01,4.41.02,8.83.02,13.25.01,2.74.01,5.48.01,8.22Z',
    r: 'l',
    y: 0.356,
    py: 0.367,
    o: -11,
  },
  { d: 'M292.42,328.03h-.05v-15.59h.04c.01,5.2.01,10.39.01,15.59Z', r: 'l', y: 0.387, py: 0.367, o: -11 },
  { d: 'M292.43,342.78v.84h-.06v-12.98h.05c.01,4.05.01,8.09.01,12.14Z', r: 'l', y: 0.412, py: 0.367, o: -11 },
  {
    d: 'M268.18,375.84c0,.58-.14,1.11-.4,1.59-.56,1.07-1.69,1.8-2.99,1.8-1.88,0-3.39-1.52-3.39-3.39s1.51-3.39,3.39-3.39c.85,0,1.64.32,2.24.84.7.62,1.15,1.53,1.15,2.55Z',
    r: 'k',
    y: 0.469,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M269.2,385.34c0,.27-.03.53-.09.78-.35,1.5-1.7,2.61-3.3,2.61-1.88,0-3.39-1.52-3.39-3.39s1.51-3.39,3.39-3.39c.39,0,.76.07,1.1.19,1.33.45,2.29,1.72,2.29,3.2Z',
    r: 'k',
    y: 0.482,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M277.4,405.11c0,1.87-1.51,3.39-3.39,3.39s-3.39-1.52-3.39-3.39c0-1.45.91-2.69,2.19-3.16.37-.15.78-.23,1.2-.23s.79.07,1.15.2c1.31.47,2.24,1.72,2.24,3.19Z',
    r: 'k',
    y: 0.511,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M298.62,223.23c-.06-.32-.14-.64-.25-.94-.16-.46-.38-.9-.64-1.3-.08-.14-.17-.27-.27-.39-.82-1.11-1.96-1.84-3.1-1.75-.22.02-.43.06-.64.15-.56.19-1.06.59-1.49,1.11-.38.48-.7,1.06-.94,1.69,0,0-.34.79-.54,1.48-.78,2.7-1.32,28.93-6.87,44.83-3.08,8.84-6.18,10.56-5.55,16.6.74,7.15,5.41,8.09,5.4,14.47-.02,7.07-6.33,8.56-5.75,15.48.43,5.14,4.02,5.58,3.87,10.6-.16,5.67-4.8,6.74-3.98,11.55.41,2.38,2.12,5.45,2.81,8.88.1.51.26,1.46.19,2.68-.35,5.69-4.22,5.4-6.9,14.33-1.07,3.59-1.02,5.57-3.07,7.71-1.29,1.34-2.93,2.01-3.87,2.88.7.62,1.15,1.53,1.15,2.55,0,.58-.14,1.11-.4,1.59,1.18.42,1.96,1.54,1.95,2.75,0,1.08-.65,2.08-1.64,2.56.12.13.39.41.61.83.05.07.08.14.12.22.02.04.04.08.06.13.02.02.02.04.03.06.03.06.06.13.08.19.06.16.11.33.14.51.02.05.02.1.03.16.03.16.04.33.04.5,0,.51-.12.94-.23,1.24.86.66,1.84,1.64,1.88,2.87.08,2.12-2.67,2.73-2.67,4.79,0,1.69,1.91,2.13,3.8,5.84.39.76.66,1.42.83,1.87.37-.15.78-.23,1.2-.23s.79.07,1.15.2c.77-2.3,1.4-6.15,1.72-8.92.9-7.54-.31-8.34,1.22-11.7,1.92-4.23,4.74-6.8,6.41-8.17.54-.45,1.09-.85,1.63-1.22v-25.69h-2.2c-.61,0-1.11-.49-1.11-1.1v-.39c0-.62.5-1.11,1.11-1.11h2.2v-12.98h-1.44c-.61,0-1.1-.5-1.1-1.11v-.39c0-.61.49-1.11,1.1-1.11h1.44v-15.59h-1.38c-.61,0-1.1-.49-1.1-1.1v-.39c0-.61.49-1.11,1.1-1.11h1.38v-21.47h-.6c-.61,0-1.11-.49-1.11-1.1v-.39c0-.61.5-1.11,1.11-1.11h6.83c0-.94,0-1.88-.01-2.82,0-3.32,0-6.65-.01-9.97v-1.1c0-.46,0-.92,0-1.38,0-7.02-.02-14.05-.04-21.07-.01-4.49-.02-9.02-.03-13.57-.01-2.53-.01-5.07-.02-7.6t.02.02c.56.69,1.27,1.17,2.09,1.24.79.06,1.57-.26,2.25-.84,1.22-1,2.11-2.79,2.1-4.5,0-.32-.03-.64-.09-.95Z',
    r: 'k',
    y: 0.373,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M326.2,159.11c0,.07-.06,10.54-.15,28.42,0,.87,0,1.76-.01,2.67-.03,8.17-.07,17.75-.11,28.48-.01,1.84-.01,3.72-.02,5.63,0,.95,0,1.92,0,2.89-.01,3.88-.03,7.89-.04,12.02,0,1.03-.01,2.07-.01,3.12-.07,21.98-.13,47.15-.17,74.01.01-12.82.03-25.29.05-37.25v-.05c.01-1.02.01-2.04.01-3.06.05-24.06.12-45.99.19-64.5.03-7.72.06-14.85.08-21.29.02-2.8.03-5.47.03-8,.05-10.39.09-18.45.12-23.63.01.18.03.36.04.54Z',
    r: 'k',
    y: 0.266,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M355.84,726.75c.31,4.14-21.03,12.33-46.71,12.32-25.68,0-47.02-8.18-46.71-12.32.01-.11.03-.2.07-.3.03-.08.07-.15.11-.22,0-.01.01-.01.01-.01.05-.08.11-.16.18-.24.06-.06.12-.13.19-.19.02-.02.03-.03.05-.05.13-.11.27-.22.43-.34.65-.48,1.59-1.06,2.8-2.01,7.22,4.01,23.86,8.5,42.87,8.49,19.01.01,35.65-4.48,42.87-8.49,1.21.95,2.15,1.53,2.8,2.01.16.12.3.23.43.34.02.02.03.03.05.05.07.06.13.13.19.19.07.08.13.16.18.24,0,0,0,0,0,.01.04.07.08.14.11.22.04.1.06.19.07.3Z',
    r: 'k',
    y: 0.989,
    py: 0.913,
    o: 48,
  },
  {
    d: 'M337.13,417.64c-.62,3.97-1.19,7.49-2.33,12.32-2,8.44-3.27,10.32-5.23,17.68-3.01,11.33-3.65,19.17-3.65,18.63-.04-8.74-.09-17.48-.14-26.23v-.66c.22-.74.54-1.82.92-3.12,1.79-6.23,2.69-9.34,3.19-12.33.53-3.23.95-5.72.57-9.04-.39-3.41-1.16-3.66-2.33-8.23-1.28-5.01-2.73-10.69.06-14.52.39-.54,1.77-2.43,3.82-2.46,2.29-.03,3.95,2.56,4.57,3.53,1.88,2.91,3.22,7.46.55,24.43Z',
    r: 'k',
    y: 0.545,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M328.13,630.85c-5.52,1.06-12.37,1.9-20.23,1.82-6.67-.07-12.56-.79-17.48-1.7l.18-7.32c5.09.75,11.03,1.3,17.65,1.29,7.46-.01,14.08-.72,19.63-1.66.09,2.53.17,5.05.25,7.57Z',
    r: 'k',
    y: 0.838,
    py: 0.913,
    o: 48,
  },
  {
    d: 'M326.05,182.2v8h-.04c-5.3-.36-10.94-.58-16.92-.58s-11.59.21-16.87.58c-.03-2.65-.06-5.3-.09-7.94v-.06c5.22-.33,10.74-.53,16.55-.54,6.11-.01,11.9.19,17.36.54h.01Z',
    r: 'k',
    y: 0.191,
    py: 0.136,
    o: -27,
  },
  {
    d: 'M324.04,132.73c-4.89-.48-10.29-.78-16.14-.74-5.2.03-10.04.32-14.47.76.16-2.66.31-5.31.46-7.97,4.1-.59,8.81-1.01,14.01-1.05,5.87-.05,11.14.41,15.64,1.06.17,2.65.34,5.29.5,7.94Z',
    r: 'k',
    y: 0.106,
    py: 0.136,
    o: -27,
  },
  {
    d: 'M300.47,99.34c0,3.74,2.54,6.89,6,7.8v5.92h-11.86c.22-4.58.5-9.26.86-14.04.04-.54.08-1.09.12-1.63h.03c-.01.15-.02.31-.03.48,0,.17-.01.35-.02.54-.01.11-.01.22-.02.34,0,.15-.01.31-.01.47,0,.16-.02.31-.02.47,0,.07-.01.14-.01.22-.04,1.05-.09,2.32-.13,3.87-.03,1.17-.07,2.52-.1,4.02h3.73c0-.23.01-.45.01-.68-.32-.55-.81-1.48-1.21-2.74-.68-2.09-.69-3.8-.69-4.64,0-.94.08-1.82.22-2.64.36-2.2,1.11-3.97,1.68-5.1,0-.23-.01-.45-.01-.68h-2.85c-.1.84-.21,1.8-.31,2.87.18-2.18.37-4.33.57-6.46.09-.92.18-1.83.27-2.74h9.81c-.01,2.19-.02,4.37-.03,6.56-3.46.91-6,4.05-6,7.79Z',
    r: 'k',
    y: 0.064,
    py: 0.041,
    o: -46,
  },
  { d: 'M295.59,97.39c.03-.32.05-.64.08-.96-.01.27-.03.59-.05.96h-.03Z', r: 'l', y: 0.06, py: 0.041, o: -46 },
  {
    d: 'M295.79,94.91c0,.12-.02.25-.03.38,0,.05-.01.1-.02.16.02-.18.03-.36.05-.54Z',
    r: 'l',
    y: 0.058,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M316.58,99.34c0-3.74-2.55-6.87-6-7.79,0-2.19-.01-4.37-.01-6.56h9.7c.16,2.11.32,4.22.49,6.33h-2.85c0,.23,0,.45,0,.68.78,1.55,1.9,4.31,1.9,7.74,0,.84-.01,2.55-.69,4.64-.4,1.26-.89,2.19-1.21,2.74,0,.23,0,.45,0,.68h3.73c-.03-1.5-.07-2.85-.1-4.02-.04-1.59-.09-2.89-.13-3.95.34,4.41.68,8.82,1.02,13.23h-11.85v-5.92c3.45-.92,6-4.06,6-7.8Z',
    r: 'k',
    y: 0.064,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M296.16,91.32c-.22,2.66-.43,5.45-.64,8.37,0-.16.01-.31.02-.47,0-.16.01-.32.01-.47.01-.12.01-.23.02-.34.01-.19.02-.37.02-.54,0-.17.02-.33.03-.48.02-.37.04-.69.05-.96.03-.44.06-.75.07-.98.01-.06.02-.11.02-.16.01-.13.02-.26.03-.38.02-.25.04-.49.06-.72.1-1.07.21-2.03.31-2.87Z',
    r: 'l',
    y: 0.058,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M297.81,104.38c.4,1.26.89,2.19,1.21,2.74,0,.23-.01.45-.01.68h-3.73c.03-1.5.07-2.85.1-4.02.04-1.55.09-2.82.13-3.87,0-.08.01-.15.01-.22.21-2.92.42-5.71.64-8.37h2.85c0,.23.01.45.01.68-.57,1.13-1.32,2.9-1.68,5.1-.14.82-.22,1.7-.22,2.64,0,.84.01,2.55.69,4.64Z',
    r: 'b',
    y: 0.064,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M321.64,107.8h-3.73c0-.23,0-.45,0-.68.32-.55.81-1.48,1.21-2.74.68-2.09.69-3.8.69-4.64,0-3.43-1.12-6.19-1.9-7.74,0-.23,0-.45,0-.68h2.85c.21,2.81.43,5.62.65,8.43v.08c.04,1.06.09,2.36.13,3.95.03,1.17.07,2.52.1,4.02Z',
    r: 'b',
    y: 0.064,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M321.41,99.75c-.22-2.81-.44-5.62-.65-8.43.1.84.21,1.8.31,2.87.02.23.04.47.06.72.01.12.02.25.03.38,0,.05.01.1.02.16.01.11.02.25.03.41,0,.11.02.22.03.35,0,.09.01.18.02.29,0,.09.01.18.02.28.03.69.08,1.65.13,2.97Z',
    r: 'l',
    y: 0.058,
    py: 0.041,
    o: -46,
  },
  {
    d: 'M319.48,76.91c-.14.07-.3.15-.48.23-2,.96-5.98,2.48-11.1,2.11-4.6-.33-8.02-2.03-9.85-3.14-.17-.1-.32-.19-.46-.28,1.32-12.46,2.67-19.48,4.04-19.72,1.64-.29,6.27-.24,6.27-.24,4.29-.06,6.64.21,6.87.24,1.84.22,2.96,3.52,4.71,20.8Z',
    r: 'm',
    y: 0.018,
    py: 0.041,
    o: -46,
  },
  { d: 'M292.43,385.34h33.24v8.69h-33.24Z', r: 'k', y: 0.489, py: 0.367, o: -11 },
  { d: 'M289.26,288.37v108.13h-3.11v-108.13h3.11Z', r: 'k', y: 0.42, py: 0.367, o: -11 },
  {
    d: 'M313.35,329.48c0,.14,0,.27-.02.41-.26,2.81-3.17,4.89-5.99,5.19-.2.02-.39.03-.59.03-.36,0-.71-.02-1.05-.08-2.12-.32-4.04-1.69-5.18-3.71-.01-.02-.02-.03-.02-.05-.09-.14-.16-.28-.23-.43-.08-.07-.15-.13-.23-.2h-15.34c-.61,0-1.1-.5-1.1-1.11v-.39c0-.61.49-1.11,1.1-1.11h15.34c.12-.02.24-.04.35-.06.01-.02.02-.03.03-.05,1.12-2.17,3.12-3.65,5.32-3.99.33-.05.67-.07,1.01-.07.2,0,.39.01.59.03,2.66.27,5.4,2.14,5.92,4.71.03.16.06.31.07.47.01.13.02.27.02.41Z',
    r: 'k',
    y: 0.401,
    py: 0.367,
    o: -11,
  },
  { d: 'M286.14,288.37h6.23v21.47h-6.23Z', r: 'l', y: 0.356, py: 0.367, o: -11 },
  { d: 'M286.14,312.44h6.23v15.59h-6.23Z', r: 'l', y: 0.387, py: 0.367, o: -11 },
  { d: 'M286.14,330.64h6.23v12.98h-6.23Z', r: 'l', y: 0.412, py: 0.367, o: -11 },
  {
    d: 'M306.65,282.4c-2.34,0-4.44,1.31-5.85,3.37h-15.26c-.61,0-1.11.5-1.11,1.11v.39c0,.61.5,1.1,1.11,1.1h13.98c-.37,1.14-.58,2.39-.58,3.7,0,5.34,3.45,9.67,7.71,9.67s7.7-4.33,7.7-9.67-3.45-9.67-7.7-9.67ZM306.95,298.58c-.52,0-.95-2.9-.95-6.46s.43-6.46.95-6.46.95,2.89.95,6.46-.42,6.46-.95,6.46Z',
    r: 'k',
    y: 0.346,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M306.65,304.17c-4.28,0-7.83,2.44-8.59,5.67h-13.3c-.61,0-1.1.5-1.1,1.11v.39c0,.61.49,1.1,1.1,1.1h13.3c.76,3.23,4.31,5.67,8.59,5.67,4.83,0,8.74-3.12,8.74-6.97s-3.91-6.97-8.74-6.97ZM306.75,315.57c-3.18,0-5.75-2.08-5.75-4.64s2.57-4.64,5.75-4.64,5.75,2.07,5.75,4.64-2.58,4.64-5.75,4.64Z',
    r: 'k',
    y: 0.374,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M307,337.65c-4.34,0-7.97,2.56-8.88,5.97h-14.18c-.61,0-1.11.49-1.11,1.11v.39c0,.61.5,1.1,1.11,1.1h14.02c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67ZM307.05,349.93c-3.26,0-5.89-2.17-5.89-4.84s2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84-2.63,4.84-5.88,4.84Z',
    r: 'k',
    y: 0.424,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M312.93,345.09c0,2.67-2.63,4.84-5.88,4.84s-5.89-2.17-5.89-4.84,2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84Z',
    r: 'b',
    y: 0.424,
    py: 0.367,
    o: -11,
  },
  { d: 'M291.96,401.72v81.63h-6.23v-81.63h6.23Z', r: 'k', y: 0.566, py: 0.663, o: 20 },
  {
    d: 'M315.44,410.41c0,3.84-3.6,6.67-6.84,6.72-2.78.04-5.41-1.95-6.73-5.1-.07-.08-.15-.16-.23-.23h-15.91c-.64-.01-1.13-.6-1.13-1.33v-.46c0-.73.49-1.32,1.13-1.33h15.91c.12-.02.24-.04.37-.07,1.33-3.02,3.89-4.93,6.59-4.91,3.25.04,6.84,2.88,6.84,6.71Z',
    r: 'k',
    y: 0.519,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M307.55,420.11c-4.34,0-7.97,2.56-8.88,5.97h-14.18c-.61,0-1.11.49-1.11,1.11v.39c0,.61.5,1.1,1.11,1.1h14.02c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67ZM307.6,432.39c-3.26,0-5.89-2.17-5.89-4.84s2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84-2.63,4.84-5.88,4.84Z',
    r: 'k',
    y: 0.545,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M307.55,446.77c-4.34,0-7.97,2.56-8.88,5.97h-14.18c-.61,0-1.11.49-1.11,1.11v.39c0,.61.5,1.1,1.11,1.1h14.02c.52,3.82,4.37,6.77,9.04,6.77,5.03,0,9.11-3.43,9.11-7.67s-4.08-7.67-9.11-7.67ZM307.6,459.05c-3.26,0-5.89-2.17-5.89-4.84s2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84-2.63,4.84-5.88,4.84Z',
    r: 'k',
    y: 0.584,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M308.15,469.18c-4.45,0-8.17,2.81-9.1,6.56h-14.53c-.63,0-1.14.54-1.14,1.22v.43c0,.67.51,1.21,1.14,1.21h14.37c.53,4.2,4.48,7.44,9.26,7.44,5.16,0,9.34-3.77,9.34-8.43s-4.18-8.43-9.34-8.43ZM308.2,482.68c-3.34,0-6.03-2.39-6.03-5.32s2.69-5.33,6.03-5.33,6.03,2.39,6.03,5.33-2.69,5.32-6.03,5.32Z',
    r: 'k',
    y: 0.617,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M313.48,427.55c0,2.67-2.63,4.84-5.88,4.84s-5.89-2.17-5.89-4.84,2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84Z',
    r: 'b',
    y: 0.544,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M313.48,454.21c0,2.67-2.63,4.84-5.88,4.84s-5.89-2.17-5.89-4.84,2.63-4.84,5.89-4.84,5.88,2.17,5.88,4.84Z',
    r: 'b',
    y: 0.583,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M314.23,477.36c0,2.93-2.69,5.32-6.03,5.32s-6.03-2.39-6.03-5.32,2.69-5.33,6.03-5.33,6.03,2.39,6.03,5.33Z',
    r: 'b',
    y: 0.617,
    py: 0.663,
    o: 20,
  },
  { d: 'M288.85,346.22h3.52v50.28h-3.52Z', r: 'k', y: 0.462, py: 0.367, o: -11 },
  { d: 'M320.46,408.5h3.21v128.36h-3.21Z', r: 'k', y: 0.61, py: 0.663, o: 20 },
  {
    d: 'M329.05,499.35c-.08.01-.16.01-.24.02-.78.06-1.58.11-2.4.15-1.04.06-2.11.11-3.21.13-.58.02-1.17.03-1.77.03-1.37.01-2.71-.01-4.01-.05-1.85-.05-3.63-.15-5.32-.28v-4.36c.56.04,1.13.07,1.71.09,2.58.13,5.33.17,8.2.09.4-.01.79-.02,1.18-.04,1.1-.04,2.17-.09,3.21-.17.81-.04,1.6-.1,2.37-.17.08-.01.16-.01.24-.02,1.59-.18,2.87.91,2.98,2.04.12,1.24-1.17,2.68-2.95,2.54Z',
    r: 'k',
    y: 0.646,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M326.34,509.53c-.06,0-.12.01-.19.01-.81.05-1.63.1-2.48.13-1.04.05-2.11.08-3.21.1-.44.01-.89.02-1.35.02-1.36.01-2.69-.01-3.98-.05-1.69-.03-3.32-.11-4.87-.21v-3.31c1.53.07,3.12.13,4.78.15,1.49.02,3.04.01,4.63-.02.27-.01.53-.01.79-.02,1.1-.03,2.17-.07,3.21-.13.84-.04,1.65-.09,2.45-.15.07,0,.13-.01.19-.01,1.25-.13,2.25.66,2.36,1.46.12.9-.86,2.08-2.33,2.03Z',
    r: 'k',
    y: 0.662,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M324.49,538.71c0,1.34-1.09,2.43-2.43,2.43s-2.42-1.09-2.42-2.43c0-.49.15-.95.4-1.33.13-.2.28-.37.46-.52.42-.36.96-.57,1.56-.57s1.14.21,1.57.57h.01c.52.45.85,1.11.85,1.85Z',
    r: 'k',
    y: 0.707,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M324.49,406.66c0,.73-.33,1.39-.84,1.84-.43.37-.98.59-1.59.59s-1.16-.22-1.58-.59c-.52-.45-.84-1.11-.84-1.84,0-1.34,1.08-2.42,2.42-2.42s2.43,1.08,2.43,2.42Z',
    r: 'k',
    y: 0.514,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M335.13,459.54h-4.05v-4.05h4.05c1.1.02,1.99.93,1.99,2.02s-.89,2.01-1.99,2.02Z',
    r: 'k',
    y: 0.588,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M335.13,452.45h-4.05v-4.05h4.05c1.1.02,1.99.93,1.99,2.02s-.89,2.01-1.99,2.02Z',
    r: 'k',
    y: 0.578,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M308.97,566.41c0,1.27,0,2.56,0,3.87-.03,10.21-.09,21.49-.2,33.59-.01,1.28-.02,2.57-.03,3.87-.01.79-.02,1.57-.02,2.37-.01.49-.02.98-.02,1.48h-3.66c0-.41,0-.82-.01-1.23v-2.62c-.01-1.3-.01-2.59-.02-3.87-.06-12.36-.15-23.65-.25-33.59-.02-1.32-.04-2.61-.05-3.87-.14-11.68-.31-21.3-.48-28.36-.04-1.45-.07-2.79-.11-4.02-.08-2.59-.15-4.68-.23-6.24-.08-1.85-.31-5.54-2.86-8.49-2.09-2.41-5.03-3.51-8.99-4.28-1.81-.36-3.84-.64-6.1-.95-8.66-1.17-12.67-.29-14.4-3.1-.92-1.5-.96-3.67,0-4.93,1.02-1.35,2.99-1.43,7.61-1.2,6.34.32,10.63.85,10.63.85.82.1,1.59.2,2.32.29,7.69.94,10.55,1.3,12.48,2.58.65.44,1.15.97,1.15.97,0,0,1.7,1.69,2.5,4.35.32,1.05.54,8.3.66,20.23.01,1.28.02,2.61.03,4,.06,7.87.08,17.42.06,28.3Z',
    r: 'k',
    y: 0.735,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M315.45,542.66v.59h-4.3v-.1c-.03-1.75-.05-3.45-.08-5.08-.02-1.37-.05-2.7-.07-3.98-.17-8.91-.35-15.64-.54-19.73-.09-1.86-.32-5.54-2.87-8.49-3.05-3.52-7.92-4.25-15.09-5.22-.13-.02-.26-.03-.38-.05-8.4-1.1-12.32-.29-14.01-3.06-.92-1.49-.96-3.67,0-4.93,1.01-1.34,2.98-1.43,7.6-1.2,2.52.13,4.72.29,6.46.44,2.63.22,4.18.41,4.18.41,9.33,1.16,12.6,1.47,14.72,2.82.45.29.84.62,1.23,1.02,0,0,1.86,1.22,2.38,3.53.06.26.1.53.12.82.09,1.37.17,3.39.24,5.92.04,1.04.06,2.17.09,3.37.14,6.4.23,14.95.28,24.19.01,1.29.01,2.6.02,3.91.01,1.6.01,3.2.02,4.82Z',
    r: 'k',
    y: 0.675,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M316.72,545.19c0,1.74-1.41,3.16-3.16,3.16s-3.16-1.42-3.16-3.16c0-.77.28-1.49.75-2.04.57-.68,1.44-1.12,2.41-1.12.72,0,1.36.23,1.89.63.77.57,1.27,1.49,1.27,2.53Z',
    r: 'k',
    y: 0.716,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M310.2,612.79c0,1.74-1.42,3.16-3.16,3.16s-3.16-1.42-3.16-3.16c0-.98.44-1.85,1.14-2.43.55-.46,1.25-.73,2.02-.73.61,0,1.19.17,1.67.48.89.56,1.49,1.55,1.49,2.68Z',
    r: 'k',
    y: 0.815,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M325.67,359.15s-.01,0-.01.01c-1.05.71-2.18.66-2.55.64-1.74-.1-3.4-1.31-4.13-2.59-.34-.57-.48-1.15-.38-1.66.06-.3.18-.49.44-.84,1.27-1.78,2.7-1.57,4.07-2.92,1.4-1.39,1.24-2.94,1.99-2.97.2-.01.38.1.56.26h.01c.41.4.73,1.14.89,1.51,1.04,2.38,1.65,6.82-.89,8.56Z',
    r: 'k',
    y: 0.437,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M325.74,261.9v16.96c0,.07,0,.13-.01.19v.05c-.12,1.21-1.14,2.15-2.37,2.15h-2.31c-1.32,0-2.39-1.07-2.39-2.39v-16.96c0-1.32,1.07-2.39,2.39-2.39h2.31c1.31,0,2.38,1.07,2.38,2.39Z',
    r: 'k',
    y: 0.314,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M313.23,259.8c0,2.63-1.75,4.84-4.14,5.56v14.99h-3.34v-14.98c-2.4-.72-4.14-2.94-4.14-5.57,0-3.21,2.6-5.81,5.81-5.81s5.81,2.6,5.81,5.81Z',
    r: 'k',
    y: 0.31,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M318.66,269.51v3.34h-14.98c-.72,2.4-2.94,4.14-5.57,4.14-2.97,0-5.42-2.23-5.76-5.11-.04-.23-.05-.46-.05-.7s.01-.46.04-.68c.34-2.88,2.79-5.13,5.77-5.13,2.63,0,4.84,1.75,5.56,4.14h14.99Z',
    r: 'k',
    y: 0.315,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M311.69,605.59v.42c0,.95-.77,1.73-1.72,1.73h-13.73c-.95,3.31-3.05,5.65-5.55,5.8-.09.02-.18.02-.27.02-3.5,0-6.34-4.34-6.34-9.69s2.84-9.69,6.34-9.69c.23,0,.46.02.68.06,3.19.51,5.67,4.63,5.67,9.63h13.2c.95,0,1.72.77,1.72,1.72Z',
    r: 'k',
    y: 0.802,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M326.34,532.9v3.5c-.86.16-1.75.32-2.67.46-.01.01-.02.01-.03.01-1.15.19-2.35.36-3.6.51-1.47.19-3.01.34-4.61.46-1.41.11-2.86.19-4.36.23-.71.03-1.43.04-2.16.04-.19.01-.37.01-.56.01-1.42.01-2.79-.02-4.13-.07-2.84-.1-5.51-.32-7.98-.62-.1.61-.63,2.49-2.3,4.2-.64.65-1.36,1.13-2.14,1.39-.44.15-.9.23-1.38.23-3.5,0-6.34-4.34-6.34-9.69s2.84-9.69,6.34-9.69c.53,0,1.05.1,1.54.29,2.76,1.05,4.81,4.86,4.81,9.4,2.32.21,4.78.38,7.34.47,1.55.05,3.14.08,4.77.08h.25c.63,0,1.25-.01,1.87-.02,1.51-.03,2.98-.08,4.41-.16,1.74-.08,3.42-.21,5.05-.35,1.1-.11,2.17-.22,3.21-.35.91-.1,1.8-.21,2.67-.33Z',
    r: 'k',
    y: 0.699,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M330.11,566.41c0,3.63-1.31,6.8-3.25,8.46-.91.79-1.97,1.23-3.09,1.23-2.61,0-4.84-2.39-5.82-5.82h-13.73c-.95,0-1.72-.78-1.72-1.73v-.42c0-.95.77-1.72,1.72-1.72h13.2c0-5.35,2.84-9.69,6.35-9.69,1.02,0,1.99.37,2.85,1.03,2.07,1.6,3.49,4.88,3.49,8.66Z',
    r: 'k',
    y: 0.747,
    py: 0.663,
    o: 20,
  },
  {
    d: 'M332.41,381.38c-.77,2.39-3.5,4.08-6.74,3.96-5.91.05-11.9.05-17.97,0-5.15-.04-10.24-.12-15.27-.22h-.06c.02-5.46.03-10.91.06-16.37v-.37c0-.83,0-1.66.01-2.49v-.3h3.79c-.06.95-.1,2.3,0,3.91.25,4,.43,6.95,2.24,9.34,2.83,3.75,8.04,3.97,9.43,4.04,3.75.16,6.64-1.15,8.61-2.04,4.64-2.11,6.17-4.52,9.16-5.26.52-.14,1.09-.22,1.72-.24.94-.03,2.81-.06,4.09,1.24,1.29,1.32,1.38,3.39.93,4.8Z',
    r: 'k',
    y: 0.468,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M325.67,333.8v16.13s-.01.01-.01.02c-.64,1.3-1.79,3.22-3.74,5.05-1.05.98-2.07,1.69-2.94,2.21-.69.42-1.29.72-1.75.95-3.73,1.84-6.92,2.09-10.19,2.31-3.31.23-6.68.46-7.52-1.19-.28-.56-.24-1.27,0-1.79.64-1.35,2.71-1.57,6.48-1.86,7.4-.58,7.74-.4,9.14-.91.72-.27,4.07-1.5,6.04-4.79,1.54-2.58,2.67-7.14.97-10.48-.41-.8-1.2-1.97-.93-3.42.04-.23.28-1.55,1.5-2.23,1.38-.76,2.82-.07,2.95,0Z',
    r: 'k',
    y: 0.426,
    py: 0.367,
    o: -11,
  },
  {
    d: 'M325.67,333.8c.49-.04,1.21-.08,2.06,0,1.13.1,1.7.15,2.05.49.98.94.17,3.19,0,3.67-.45,1.25-.87,1.35-1.28,2.28-.43.97-.48,1.98.43,5.97.86,3.79,1.13,3.9,1.33,5.75.24,2.26.38,3.79-.56,5.13-1.17,1.67-3.3,1.98-4.02,2.05v-25.35Z',
    r: 'k',
    y: 0.426,
    py: 0.367,
    o: -11,
  },
]
